import moduleTemplate from '@/store/moduleTemplate'
import ioParametersAPI from '@/api/ioParameters'

export default moduleTemplate(ioParametersAPI)
